import React, { useContext, useEffect, useState } from 'react'
import Sider from 'antd/es/layout/Sider'
import Search from 'antd/lib/input/Search'
import { Button, Layout, Menu } from 'antd'
import { AppContext } from '../../App'
import { Content } from 'antd/es/layout/layout'
import { WrapperData } from '../../style/style'
import BottomMenuInfo from '../../modules/BottomMenuInfo/BottomMenuInfo'
import AddingHuntingGroundsModal from './modal/AddingHuntingGroundsModal'
import validatorServerErrors from '../../modules/ValidatorServerErrors/ValidatorServerErrors'
import MyTable from '../../modules/MyTable/MyTable'
import { adminMenu } from '../../lists/adminMenu'
import { useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { getRequest, getRequestNew } from '../../request/request'
import { parseUrl } from '../../function/parseUrl'
import { ColumnsType } from 'antd/es/table'
import { ContextType } from '../../type/type'

const AddingHuntingGrounds = () => {
  const { state, isMobileWidth } = useContext<ContextType>(AppContext)
  const { t } = useTranslation()
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const type = pathname.split('/cabinet/')[1]
  const [data, setData] = useState<any[] | null>(null)
  const [typeModal, setTypeModal] = useState<string | null>(null)
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
  const [clearForm, setClearForm] = useState<boolean>(false)
  const [editData, setEditData] = useState(null)
  const [regionData, setRegionData] = useState<any[] | null>(null)
  const [regionDataLoading, setRegionDataLoading] = useState<boolean>(false)
  const [reload, setReload] = useState<boolean>(false)
  const [sortOrder, setSortOrder] = useState<any | null>(null)
  const [loading, setLoading] = useState(false)
  const [dataSearch, setDataSearch] = useState('')
  const [pagination, setPagination] = useState(() => {
    const urlParams = new URLSearchParams(location.search)
    return {
      current: parseInt(urlParams.get('page') || '1', 10),
      pageSize: 10,
      total: 0,
    }
  })
  const [reloadPagination, setReloadPagination] = useState(false)

  const columns: ColumnsType = [
    {
      title: t('h153'),
      dataIndex: 'title',
      key: 'title',
      width: 120,
      sorter: true,
      sortOrder: sortOrder?.field === 'title' ? sortOrder.order : undefined,
    },
    {
      title: t('h154'),
      dataIndex: 'region',
      key: 'region',
      align: 'center',
      width: 100,
      sorter: true,
      sortOrder: sortOrder?.field === 'region' ? sortOrder.order : undefined,
    },
  ]
  const [collapsed, setCollapsed] = useState(false)
  const [breakpoint, setBreakpoint] = useState(false)

  const handleCollapse = (collapsed: boolean, type: string) => {
    if (type === 'clickTrigger') setCollapsed(collapsed)
  }

  const handleClickMenu = () => {
    if (breakpoint) setCollapsed(true)
  }

  useEffect(() => {
    getRequest('/maps/region/?page-size=-1')
      .then((res) => {
        setRegionData(res.data.results)
        setRegionDataLoading(false)
      })
      .catch(() => {
        setRegionDataLoading(false)
      })
  }, [state.lang])

  useEffect(() => {
    setLoading(true)
    setRegionDataLoading(true)

    const query = location.search.split('?')[1]
    const search = parseUrl('?', 'search')
    const ordering = parseUrl('?', 'ordering')

    if (search) setDataSearch(search)
    if (ordering) defaultOrdering(ordering)

    getRequestNew(`/trophy_book/hunting_farm?${query || ''}`)
      .then((res) => {
        setLoading(false)
        setPagination({
          ...pagination,
          total: res.data.count,
        })
        setData(res.data.results)
      })
      .catch((err) => {
        validatorServerErrors(err.data)
        setLoading(false)
      })
  }, [reload, reloadPagination, state])

  const defaultOrdering = (ordering: string) => {
    const parts = ordering.split('-')

    if (parts.length > 1) {
      setSortOrder({ field: parts[1], order: 'descend' })
    } else {
      setSortOrder({ field: parts[0], order: 'ascend' })
    }
  }

  const handleCallbackModal = (e: boolean) => {
    setIsModalOpen(e)
    setEditData(null)
  }

  const showModal = () => {
    setIsModalOpen(true)
  }

  const trophiesAdd = () => {
    setTypeModal('add')
    showModal()
    setClearForm((prev) => !prev)
  }

  //
  // const callbackModal = (data: any) => {
  //   // if (role === 'ADMINISTRATOR' || role === 'MODERATOR') {
  //   //   setTypeModal('admin')
  //   //   setEditData(data)
  //   //   showModal()
  //   // } else {
  //   //   if (data.status === 'AWT') {
  //   //     setTypeModal('edit')
  //   //     setEditData(data)
  //   //     showModal()
  //   //   } else {
  //   //     setTypeModal('view')
  //   //     setEditData(data)
  //   //     showModal()
  //   //     // message.error(t('h97'))
  //   //   }
  //   // }
  //   setTypeModal('view')
  //   setEditData(data)
  //   showModal()
  // }

  const onSearch = (value: string) => {
    setLoading(true)
    setDataSearch(value)
    setSortOrder(null)

    if (!value) {
      navigate('/cabinet/adding-hunting-grounds')
      getRequestNew(`/trophy_book/hunting_farm`)
        .then((res) => {
          setData(res.data.results)
          setPagination({
            ...pagination,
            current: 1,
            total: res.data.count,
          })
          setLoading(false)
        })
        .catch((err) => {
          setLoading(false)
          validatorServerErrors(err.data)
        })
    } else {
      getRequestNew(`/trophy_book/hunting_farm?search=${value}`)
        .then((res) => {
          setData(res.data.results)
          navigate(`?search=${value}`)
          setPagination({
            ...pagination,
            current: 1,
            total: res.data.count,
          })
          setLoading(false)
        })
        .catch((err) => {
          setLoading(false)
          validatorServerErrors(err.data)
        })
    }
  }

  return (
    <Layout className="br-12">
      <Content>
        <WrapperData>
          <AddingHuntingGroundsModal
            isModalOpen={isModalOpen}
            setIsModalOpen={handleCallbackModal}
            setReload={setReload}
            editData={editData}
            clearForm={clearForm}
            typeModal={typeModal}
            regionData={regionData}
            regionDataLoading={regionDataLoading}
          />

          {/*<Search*/}
          {/*  placeholder={t('h45')}*/}
          {/*  allowClear*/}
          {/*  enterButton={t('h45')}*/}
          {/*  size="large"*/}
          {/*  value={dataSearch}*/}
          {/*  onChange={({ target }) => {*/}
          {/*    setDataSearch(target.value)*/}
          {/*  }}*/}
          {/*  onSearch={onSearch}*/}
          {/*  className="search-trophies"*/}
          {/*/>*/}
          {/*<br />*/}
          {/*<br />*/}

          <Button
            onClick={trophiesAdd}
            style={{
              marginBottom: 20,
              backgroundColor: '#4A552E',
              color: '#fff',
              borderColor: '#4A552E',
              boxShadow: '0 1px 4px 1px #E8EDE9',
            }}
          >
            {t('profile.p5')}
          </Button>

          {/*<MyTable*/}
          {/*  columns={columns}*/}
          {/*  data={data}*/}
          {/*  loading={loading}*/}
          {/*  height={900}*/}
          {/*  pagination={pagination}*/}
          {/*  setPagination={setPagination}*/}
          {/*  setReloadPagination={setReloadPagination}*/}
          {/*  setSortOrder={setSortOrder}*/}
          {/*  sortOrder={sortOrder}*/}
          {/*  scroll={{ x: '100%' }}*/}
          {/*/>*/}
        </WrapperData>
      </Content>
    </Layout>
  )
}

export default AddingHuntingGrounds
